import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { ColumnType } from "antd/lib/table";
import BasicTable from "@components/core/tables/BasicTable";
import TableRow from "@components/core/tables/TableRow";

interface SortableTableProps<T> {
  isDraggable?: boolean;
  data: T[];
  setData: (data: T[]) => void;
  columns: ColumnType<T>[];
  className?: string;
}

const SortableTable = <T extends { key: string }>({
  isDraggable = true,
  data,
  setData,
  columns,
  className = "",
}: SortableTableProps<T>): JSX.Element => {
  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      const activeIndex = data.findIndex((i) => i.key === active.id);
      const overIndex = data.findIndex((i) => i.key === over?.id);
      setData(arrayMove(data, activeIndex, overIndex));
    }
  };

  const renderTable = () => (
    <BasicTable
      components={{
        body: {
          row: TableRow,
        },
      }}
      rowKey="key"
      pagination={false}
      columns={columns}
      dataSource={data}
    />
  );

  return (
    <div className={`app-table-sortable ${className}`}>
      {isDraggable ? (
        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
          <SortableContext
            // rowKey array
            items={data.map((i) => i.key)}
            strategy={verticalListSortingStrategy}
          >
            {renderTable()}
          </SortableContext>
        </DndContext>
      ) : (
        renderTable()
      )}
    </div>
  );
};

export default SortableTable;
